export const LABEL_KEY = 'label';
export const DAY_NAME_STRING = 'dddd';

export const LABEL_COLUMN = { dataIndex: LABEL_KEY, title: '' };
export const TABLE_SCROLL_SETTINGS = { x: true };
export const COLUMN_SPLIT_CHAR_SEQUENCE = '|_|';
